import { useEffect, useState } from 'react';

export const useHasCursor = (initial = false): boolean => {
  const [hasCursor, setHasCursor] = useState(initial);
  useEffect(() => {
    setHasCursor(window.matchMedia('(pointer:fine)').matches);
  }, []);
  return hasCursor;
};
